import script from "./CadastroPadrao.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroPadrao.vue?vue&type=script&setup=true&lang=js"

import "./CadastroPadrao.vue?vue&type=style&index=0&id=5e15f495&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e15f495"]])

export default __exports__